<template>
	<tr :class="{ 'table-info': candidateStock.editId == stock.id, 'table-success': candidateStock.saveId == stock.id }">

	<td>
		<strong>{{ stock.vendor.name }}</strong>
		<span v-if="stock.vendor.id == 21"> (LZ: {{ stock.vendorDeliveryTime }})</span>
	</td>
	<td v-if="vendorCanEditArticleId(stock.vendor) && stock.id === stockSaveProcessing">
		<b-spinner style="width: 1rem; height: 1rem" label="loading..."/>
	</td>
	<td
		v-else-if="vendorCanEditArticleId(stock.vendor) && stock.id === candidateStock.editId"
		class="align-middle"
		style="max-width: 75px"
	>
		<div class="input-group input-group-sm">
			<input
				v-bind:id="'articleIdInput_' + candidateStock.editId"
				type="text"
				style="text-align: center"
				class="form-control"
				v-model="candidateStock.articleId"
				@keypress.enter="stockSave(candidateStock.editId)"
			/>
		</div>
	</td>
	<td v-else-if="stock.articleId" @click="editStock(stock, 'articleId')">{{stock.articleId}}</td>
	<td v-else @click="editStock(stock, 'articleId')">—</td>
	<td>
		<span v-if="stock.articleCondition == 1">Neu</span>
		<span v-else-if="stock.articleCondition == 2">Gebraucht</span>
		<span v-else>—</span>
	</td>
	<td v-if="vendorCanEditArticleId(stock.vendor) && stock.id === stockSaveProcessing">
		<b-spinner style="width: 1rem; height: 1rem" label="loading..."/>
	</td>
	<td
		v-else-if="stock.id == candidateStock.editId"
		class="align-middle"
		style="max-width: 75px"
	>
		<div class="input-group input-group-sm">
			<input
				v-bind:id="'purchasePriceInput_' + candidateStock.editId"
				type="text"
				style="text-align: left"
				class="form-control"
				v-model="candidateStock.purchasePrice"
				@keypress.enter="stockSave(candidateStock.editId)"
			/>
			<div class="input-group-append mb-auto">
				<span class="input-group-text">€</span>
			</div>
		</div>
	</td>
	<td v-else @click="editStock(stock)">
		<popper trigger="hover" :options="{placement: 'left'}">
			<div class="popper">
				Eingangsporto: {{ Number(stock.vendorShippingFee).toFixed(2) }} € <br>
				<p v-if="_.isNumber(stock.ekGoal)">Referenzpreis US: {{ Number(stock.ekGoal).toFixed(2) }} €</p>
			</div>
			<p href="#" slot="reference" class="top mb-0">{{ Number(stock.purchasePrice).toFixed(2) }} €</p>
		</popper>
	</td>
	<td id="column-eingangsporto">
		<span style="color:Gray">{{Number(stock.vendorShippingFee).toFixed(2)}}€</span>
	</td>
	<td id="column-summe">{{ stock.sumPurchasePriceAndShippingFeeStr }}€</td>
	<td v-if="vendorCanEditArticleId(stock.vendor) && stock.id === stockSaveProcessing">
		<b-spinner style="width: 1rem; height: 1rem" label="loading..."/>
	</td>
	<td v-else-if="stock.id == candidateStock.editId" class="align-middle">
		<div class="input-group input-group-sm" style="width: 42px">
			<input
				v-bind:id="'quantityInput' + candidateStock.editId"
				type="text"
				style="text-align: center"
				class="form-control"
				v-model="candidateStock.quantity"
				@keypress.enter="stockSave(candidateStock.editId)"
			/>
		</div>
	</td>
	<td v-else @click="editStock(stock)">{{ stock.quantity }}</td>
	<td>
		LK <b>{{ stock.vendor.deliveryClass }}</b>
	</td>
	<td>{{ stock.sku }}</td>
	<td v-if="candidateStock.editId == stock.id" style="height: 38px">
		<button
			type="button"
			class="btn btn-sm btn-primary pr-1"
			@click="stockSave(candidateStock.editId)"
		>
			<span class="icon icon-checkmark"></span>
		</button>
		<button
			type="button"
			class="btn btn-secondary btn-sm"
			@click="resetCandidateStock(stock.id)"
		>
			<span class="icon icon-cross"></span>
		</button>
	</td>
	<td v-else style="height: 38px">
		<b-spinner
			v-if="
				vendorCanEditArticleId(stock.vendor) &&
				stock.id === stockSaveProcessing
			"
			label="loading..."
		/>
		<div v-else-if="candidateStock.editId == null && (authorization.account_assistant || authorization.shipping_assistant)">
			<b-button-group>
				<button 
					type="button"
					class="btn btn-secondary btn-sm pr-1"
					@click="editStock(stock)"
				>
					<span class="icon icon-pencil"></span>
				</button>
				<button
					type="button"
					class="btn btn-secondary btn-sm float-right"
					@click="emit_openManualVendorOrder(stock)"
				>
					<!-- button -->
					<span
						class="icon icon-cart"
						title="Manuelle Händlerbestellung"
					/>
				</button>
				<b-button 
				:variant="stock.vendorStockBlock ? 'danger': 'secondary'" 
				size="sm" 
				v-if="(authorization.warehouse_manager || authorization.account_manager|| userIsSevgi || userIsFlorian || userIsSebastian || userIsSvenja)"
        :disabled="disableVendorstockBlockButton"
				@click="emit_openVendorStockBlock">
					<b-icon font-scale="1" icon="dash-circle"></b-icon>
				</b-button>
			</b-button-group>
		</div>
	</td>
</tr>
</template>
<script>
export default {
	props: ["stock", "stocks", "candidateStock", "authorization", "userName" ],
	data() {
		return {
			stockSaveProcessing: false,
			userIsSevgi : (this.userName && new String(this.userName.username).startsWith('Sevgi')),
			userIsSebastian : (this.userName && new String(this.userName.username).localeCompare('Sebastian Klupsch') === 0),
			userIsSvenja : (this.userName && new String(this.userName.username).localeCompare('Svenja Junker') === 0),
			userIsFlorian : (this.userName && new String(this.userName.username).localeCompare('Florian') === 0),
		}
	},
  computed:{
    disableVendorstockBlockButton(){
      if(this.authorization.master === false && this.stock.vendor.hasVirtualStocks === 0) 
      {return true;} else {return false;}
    }
  },
	methods: {
		vendorCanEditArticleId: function (vendor) {
			const regexLagerPattern = new RegExp("^Lager[0-9]{1,}$|^Ausschussware( 7%)?$");
			return regexLagerPattern.test(vendor.name);
		},		
		editStock(stock, field) {
			// do not copy stuff nor activate edit menu if we clicked on the articleId <td> and
			// the vendor isn't Lager 2 or 4 (i.e. is not in the vendorCanEdit liststock).
			if (field == "articleId" && !this.vendorCanEditArticleId(stock.vendor)) {
				return;
			}

			if (this.candidateStock.editId == null) {
				this.candidateStock.editId = stock.id;
				this.candidateStock.purchasePrice = Number(stock.purchasePrice).toFixed(2);
				this.candidateStock.quantity = stock.quantity;
				if (this.vendorCanEditArticleId(stock.vendor)) {
					this.candidateStock.articleId = stock.articleId;
				}
			}
		},
		stockSave() {
			let stock = this.stocks.find(
				(candidate) => candidate.id == this.candidateStock.editId
			);
			if (
				this.candidateStock.quantity == stock.quantity &&
				this.candidateStock.purchasePrice == stock.purchasePrice &&
				this.candidateStock.articleId == stock.articleId
			) {
				this.candidateStock.saveId = null;
				this.candidateStock.editId = null;
				return false;
			}
			this.candidateStock.saveId = this.candidateStock.editId;
			this.candidateStock.editId = null;
			let strippedStock = {
				id: stock.id,
				quantity:
					this.candidateStock.quantity != null
						? this.forceNumeric(this.candidateStock.quantity)
						: this.forceNumeric(stock.quantity),
				purchasePrice:
					this.candidateStock.purchasePrice != null
						? this.forceNumeric(this.candidateStock.purchasePrice)
						: this.forceNumeric(stock.purchasePrice),
			};
			this.candidateStock.purchasePrice = null;
			this.candidateStock.quantity = null;
			if (strippedStock.articleId !== null) {
				strippedStock.articleId = this.candidateStock.articleId;
			}
			this.stockSaveProcessing = strippedStock.id;
			axios
				.post("/stock/save", strippedStock)
				.then((response) => {
					// console.log(response);
					this.stockSaveProcessing = 0;
					stock.quantity = strippedStock.quantity;
					stock.purchasePrice = strippedStock.purchasePrice;
					if (strippedStock.articleId !== null) {
						stock.articleId = strippedStock.articleId;
					}
					this.stocks.sort((v, w) => {
						return Number(v.purchasePrice) - Number(w.purchasePrice);
					});
					this.candidateStock.editId = null;
					this.resetCandidateStock()
				})
				.catch((error) => {
					this.stockSaveProcessing = 0;
					this.modalError.error = error.toString();
					this.modalError.show = true;
					this.candidateStock.saveId = null;
					this.resetCandidateStock()
				});
		},
		forceNumeric(mangledNumber) {
			return Number(mangledNumber.toString().replace(',','.'));
		},
		resetCandidateStock(candidateId)
		{
			this.candidateStock.editId = null;
			this.candidateStock.quantity = null;
			this.candidateStock.purchasePrice = null;
			this.candidateStock.articleId = null;
		},
		emit_openManualVendorOrder() {
			this.$emit('openManualVendorOrder', this.stock);
		},
		emit_openVendorStockBlock() {
			this.$emit('openVendorStockBlock', this.stock);
		},
	}
}
</script>
